/*global alertify, is */

var messages = (function (alertify, is) {
    var errors = ['errors', 'detail'],
        err_class = 'readly-error',
        info_class = 'readly-info';

    var notify = function (msg, args) {
            args.unshift(msg);
            alertify.log.apply(null, args);
        },
        err = function (msg, args) {
            args[0] = err_class;
            notify(msg, args);
        },
        info = function (msg, args) {
            args[0] = info_class;
            notify(msg, args);
        },
        getErrorProperty = function (data) {
            var i, len;
            for (i = 0, len = errors.length; i < len; i++) {
                if (data && data.hasOwnProperty(errors[i]))
                    return errors[i];
            }
            return null;
        },

        getMessages = function (data) {
            var errors = getErrorProperty(data),
                msgs;

            if (is.object(data) && errors) {
                if (is.array(data[errors])) {
                    msgs = data[errors];
                } else if (is.string(data[errors]) && data[errors]) {
                    msgs = [data[errors]];
                } else if (is.object(data[errors])) {
                    msgs = [];
                    for (var key in data[errors]) {
                        if (data[errors].hasOwnProperty(key)) {
                            for (var j in data[errors][key]) {
                                var error_text = key + ': ' + data[errors][key][j];
                                msgs.push(error_text);
                            }
                        }
                    }
                }
            } else if (is.string(data) && data) {
                msgs = [data];
            }

            return msgs;
        };

    return {
        error: function (data) {
            var args = [].slice.call(arguments),
                msgs = getMessages(data),
                i, len;

            if (!msgs) {
                return;
            }

            for (i = 0, len = msgs.length; i < len; i++) {
                err(msgs[i], args);
            }
        },
        info: function (msg) {
            var args = [].slice.call(arguments);
            info(msg, args);
        },
        errorText: getMessages
    };
}(alertify, is));
